import {
  AnalyticsDataPointTypesEnum,
  AnalyticsScalarMetric,
  AnalyticsScalarMetricsEnum,
} from '../../models/api/analyticsMetricsModel';

/**
 * For computed metrics duration, percentage, ... metrics, a value of 0 should be considered as no value (used to hide the variation or display the empty state)
 * For numerical metrics, 0 is a valid value and should be displayed.
 */
export function isZeroValidForScalarMetric(metric: AnalyticsScalarMetric) {
  // Only exception is metrics in this array which are of type numerical, but are computed and should be hidden when 0.
  if ([AnalyticsScalarMetricsEnum.STAGE_AVG_REPLIES_TO_RESOLUTION].includes(metric.id)) {
    return false;
  }
  return metric.type === AnalyticsDataPointTypesEnum.NUMERICAL;
}
